import { Preferences } from "../../profile/objects/preferences";
import { Column } from "../objects/column";
import { ListPreferenceResult, setListPreference } from "../../utils/list/utils/setListPreference";
import { DEFAULT_COLUMN, SPECIAL_OFFER_MODULE } from "./specialOffer";

export const setSpecialOfferPreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: SPECIAL_OFFER_MODULE,
        default_columns: DEFAULT_COLUMN,
        default_order_by: '',
        default_order: 'asc',
    });
